<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="format-switcher">
    <app-context-menu [options]="{ width: '360px', noSpacing: true }" verticalPosition="bottom" #fromMenu>
      <button
        appButton
        name="from-format"
        location="conversion-format-switcher"
        contextButton
        shape="round"
        height="3"
        weight="bold"
        [hasIcon]="true"
      >
        <span>{{ ((fromFormat$ | async)?.slug | uppercase) || 'Choose' }}</span>
        <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
      </button>
      <div contextContent>
        <app-conversion-format-select-menu-content
          *ngIf="fromMenu.isOpen"
          [mode]="'from'"
          [linkMode]="true"
          [fromFormat]="fromFormat$ | async"
          [toFormat]="toFormat$ | async"
        ></app-conversion-format-select-menu-content>
      </div>
    </app-context-menu>
    <app-svg src="/assets/icons/arrow-right.svg"></app-svg>
    <app-context-menu [options]="{ width: '360px', noSpacing: true }" verticalPosition="bottom" #toMenu>
      <button
        appButton
        name="to-format"
        location="conversion-format-switcher"
        contextButton
        shape="round"
        height="3"
        weight="bold"
        [hasIcon]="true"
      >
        <span>{{ ((toFormat$ | async)?.slug | uppercase) || 'Choose' }}</span>
        <app-svg src="/assets/icons/chevron-down.svg" size="0"></app-svg>
      </button>
      <div contextContent>
        <app-conversion-format-select-menu-content
          *ngIf="toMenu.isOpen"
          [simpleMode]="true"
          [mode]="'to'"
          [linkMode]="true"
          [fromFormat]="fromFormat$ | async"
          [toFormat]="toFormat$ | async"
        ></app-conversion-format-select-menu-content>
      </div>
    </app-context-menu>
  </div>
</app-block-wrapper>
